<template>
  <div>
    <div class="page-header-wrapper" v-if="showHeader">
      <div class="page-header">
        <h1 class="page-title"><slot name="page-title"></slot></h1>
        <!-- <div class="description-card" v-if="$slots['page-description']">
          <slot name="page-description"></slot>
        </div> -->
      </div>
      <v-divider v-if="!mobile"></v-divider>
      <p class="page-subtitle"><slot name="page-subtitle"></slot></p>
    </div>
    <slot name="default"></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const name = 'page'

const props = {
  showHeader: {
    type: Boolean,
    required: false,
    default: true
  }
}

const computed = {
  ...mapGetters({
    mobile: 'ux/mobile'
  })
}

export default {
  name,
  props,
  computed
}
</script>



// WEBPACK FOOTER //
// src/components/Page.vue